import palette from '../palette';

export default {
  root: {
    padding: '44px 20px 22px 74px',
    backgroundColor: palette.neutrals[2],
  },
};
